import { trpc } from '@tencent/tpro_rmonitor_product_manager_role';
import { useEffect, useState } from 'react';
import { getProductId } from '@/infrastructure/product-info';
import { roleService } from '@/service/role';
import { WithTypeCast } from '@raft/utils';
type IRoleInfo = WithTypeCast<trpc.rmonitor.product_manager.IRoleInfo>;

interface RolesOption {
  value: number;
  label: string;
}

export const useRole = () => {
  const [rolesOption, setRolesOption] = useState<RolesOption[]>([]);

  const load = async () => {
    const roles = await roleService.getRoles({
      productId: getProductId(),
    });
    const rolesOption: RolesOption[] = roles.map((item: IRoleInfo) => (
      {
        value: item.id as number,
        label: item.name as string,
      }));
    setRolesOption(rolesOption);
  };

  useEffect(() => {
    load();
  }, []);

  return { rolesOption };
};
